import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Chip,
  Button,
  Link as MuiLink,
} from '@mui/material';
import { motion } from 'framer-motion';
import { OpenInNew, Code, CalendarToday } from '@mui/icons-material';
import profileConfig from '../constants/profileConfig';

const Projects = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2 },
    },
  };
  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  };

  return (
    <Box sx={{ py: 4 }}>
      <Container maxWidth="lg">
        <motion.div variants={containerVariants} initial="hidden" animate="visible">
          <motion.div variants={itemVariants}>
            <Typography variant="h2" align="center" sx={{ mb: 2, fontWeight: 600 }}>
              Completed Projects
            </Typography>
            <Typography variant="h6" align="center" color="text.secondary" sx={{ mb: 6 }}>
              Showcasing research and industrial projects
            </Typography>
          </motion.div>
          <Grid container spacing={3}>
            {(profileConfig.projects || []).map((project, idx) => (
              <Grid item xs={12} sm={6} md={4} key={project.title || idx}>
                <motion.div variants={itemVariants} whileHover={{ scale: 1.03 }}>
                  <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', borderRadius: 3, boxShadow: 3, transition: 'box-shadow 0.3s', '&:hover': { boxShadow: 8 }, p: { xs: 1, sm: 2 } }}>
                    <CardMedia
                      component="img"
                      height="180"
                      image={project.image || ''}
                      alt={project.title || ''}
                      sx={{ objectFit: 'cover', width: '100%', height: { xs: 140, sm: 180 } }}
                    />
                    <CardContent sx={{ flexGrow: 1, p: { xs: 1, sm: 2 } }}>
                      <Typography variant="h6" sx={{ fontWeight: 600, mb: 1, fontSize: { xs: '1rem', sm: '1.1rem' } }}>
                        {project.title || '-'}
                      </Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ mb: 2, fontSize: { xs: '0.9rem', sm: '1rem' } }}>
                        {project.description || '-'}
                      </Typography>
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
                        {(project.technologies || []).map((tech, i) => (
                          <Chip key={i} label={tech || '-'} size="small" icon={<Code />} />
                        ))}
                      </Box>
                      <Box sx={{ mb: 2 }}>
                        {(project.outcomes || []).map((outcome, i) => (
                          <Typography key={i} variant="body2" sx={{ display: 'block', fontStyle: 'italic', fontSize: { xs: '0.85rem', sm: '1rem' } }}>
                            • {outcome || '-'}
                          </Typography>
                        ))}
                      </Box>
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, alignItems: 'center' }}>
                        {project.year && !isNaN(project.year) ? <Chip label={project.year} size="small" icon={<CalendarToday />} /> : <Chip label="-" size="small" icon={<CalendarToday />} />}
                        {project.link ? (
                          <Button
                            component={MuiLink}
                            href={project.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            size="small"
                            endIcon={<OpenInNew />}
                            sx={{ mt: { xs: 1, sm: 0 } }}
                          >
                            View
                          </Button>
                        ) : null}
                      </Box>
                    </CardContent>
                  </Card>
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </motion.div>
      </Container>
    </Box>
  );
};

export default Projects; 